import * as Types from '../../types/bff/gql-schema';

import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { gqlFetcher } from '@/utils/fetcher';

export const NonBenefitMedicinesForSeoDocument = `
    query NonBenefitMedicinesForSeo {
  nonBenefitMedicinesForSeo {
    id
    medicineName
    medicineDescription
    units {
      id
      unit
      unitType
      unitTypeDisplayName
    }
    treatment {
      id
      categoryId
      isBenefit
      name
    }
  }
}
    `;
export const useNonBenefitMedicinesForSeoQuery = <
      TData = Types.NonBenefitMedicinesForSeoQuery,
      TError = Types.GraphqlError
    >(
      variables?: Types.NonBenefitMedicinesForSeoQueryVariables,
      options?: UseQueryOptions<Types.NonBenefitMedicinesForSeoQuery, TError, TData>,
    ) =>
    useQuery<Types.NonBenefitMedicinesForSeoQuery, TError, TData>(
      variables === undefined ? ['NonBenefitMedicinesForSeo'] : ['NonBenefitMedicinesForSeo', variables],
      gqlFetcher<Types.NonBenefitMedicinesForSeoQuery, Types.NonBenefitMedicinesForSeoQueryVariables>(NonBenefitMedicinesForSeoDocument, 'NonBenefitMedicinesForSeo', variables),
      options
    );

useNonBenefitMedicinesForSeoQuery.getKey = (variables?: Types.NonBenefitMedicinesForSeoQueryVariables) => variables === undefined ? ['NonBenefitMedicinesForSeo'] : ['NonBenefitMedicinesForSeo', variables];
;

useNonBenefitMedicinesForSeoQuery.fetcher = (variables?: Types.NonBenefitMedicinesForSeoQueryVariables, options?: RequestInit['headers']) => gqlFetcher<Types.NonBenefitMedicinesForSeoQuery, Types.NonBenefitMedicinesForSeoQueryVariables>(NonBenefitMedicinesForSeoDocument, 'NonBenefitMedicinesForSeo', variables, options);
export const NonBenefitPriceTotalSummaryDocument = `
    query NonBenefitPriceTotalSummary($treatmentMedicineId: ID!, $regionCode: String!) {
  nonBenefitPriceTotalSummary(
    treatmentMedicineId: $treatmentMedicineId
    regionCode: $regionCode
  ) {
    nationalSummaries {
      averagePrice
      minPrice
      treatmentMedicineUnitId
      unitDisplayName
      unitTypeDisplayName
    }
    regionSummaries {
      averagePrice
      minPrice
      treatmentMedicineUnitId
      unitDisplayName
      unitTypeDisplayName
    }
  }
}
    `;
export const useNonBenefitPriceTotalSummaryQuery = <
      TData = Types.NonBenefitPriceTotalSummaryQuery,
      TError = Types.GraphqlError
    >(
      variables: Types.NonBenefitPriceTotalSummaryQueryVariables,
      options?: UseQueryOptions<Types.NonBenefitPriceTotalSummaryQuery, TError, TData>,
    ) =>
    useQuery<Types.NonBenefitPriceTotalSummaryQuery, TError, TData>(
      ['NonBenefitPriceTotalSummary', variables],
      gqlFetcher<Types.NonBenefitPriceTotalSummaryQuery, Types.NonBenefitPriceTotalSummaryQueryVariables>(NonBenefitPriceTotalSummaryDocument, 'NonBenefitPriceTotalSummary', variables),
      options
    );

useNonBenefitPriceTotalSummaryQuery.getKey = (variables: Types.NonBenefitPriceTotalSummaryQueryVariables) => ['NonBenefitPriceTotalSummary', variables];
;

useNonBenefitPriceTotalSummaryQuery.fetcher = (variables: Types.NonBenefitPriceTotalSummaryQueryVariables, options?: RequestInit['headers']) => gqlFetcher<Types.NonBenefitPriceTotalSummaryQuery, Types.NonBenefitPriceTotalSummaryQueryVariables>(NonBenefitPriceTotalSummaryDocument, 'NonBenefitPriceTotalSummary', variables, options);
export const SearchNonF2fDoctorsForSeoByUserDocument = `
    query SearchNonF2fDoctorsForSeoByUser($request: NonF2fDoctorSeoSearchRequestInput!, $contactType: DiagnosisContactType!) {
  searchNonF2fDoctorsForSeoByUser(request: $request) {
    doctorId
    name
    medicineType
    readyForVideoCall
    publicId
    nonBenefitTreatmentsV2(contactType: $contactType) {
      nonBenefitTreatmentUnitInfos {
        originalPrice
        unitDisplayName
        treatmentMedicineUnitId
      }
    }
    detail {
      profileImageUrl
    }
    departments {
      name
      isProfessional
    }
    hospital {
      hospitalName
      hospitalAddress {
        jibunAddress
        roadAddress
        regionByDepth {
          siDoName
          siGunGuName
          legalEupMyeonDongName
        }
      }
    }
  }
}
    `;
export const useSearchNonF2fDoctorsForSeoByUserQuery = <
      TData = Types.SearchNonF2fDoctorsForSeoByUserQuery,
      TError = Types.GraphqlError
    >(
      variables: Types.SearchNonF2fDoctorsForSeoByUserQueryVariables,
      options?: UseQueryOptions<Types.SearchNonF2fDoctorsForSeoByUserQuery, TError, TData>,
    ) =>
    useQuery<Types.SearchNonF2fDoctorsForSeoByUserQuery, TError, TData>(
      ['SearchNonF2fDoctorsForSeoByUser', variables],
      gqlFetcher<Types.SearchNonF2fDoctorsForSeoByUserQuery, Types.SearchNonF2fDoctorsForSeoByUserQueryVariables>(SearchNonF2fDoctorsForSeoByUserDocument, 'SearchNonF2fDoctorsForSeoByUser', variables),
      options
    );

useSearchNonF2fDoctorsForSeoByUserQuery.getKey = (variables: Types.SearchNonF2fDoctorsForSeoByUserQueryVariables) => ['SearchNonF2fDoctorsForSeoByUser', variables];
;

useSearchNonF2fDoctorsForSeoByUserQuery.fetcher = (variables: Types.SearchNonF2fDoctorsForSeoByUserQueryVariables, options?: RequestInit['headers']) => gqlFetcher<Types.SearchNonF2fDoctorsForSeoByUserQuery, Types.SearchNonF2fDoctorsForSeoByUserQueryVariables>(SearchNonF2fDoctorsForSeoByUserDocument, 'SearchNonF2fDoctorsForSeoByUser', variables, options);
export const NonBenefitMapNearbyPharmacySearchTabsDocument = `
    query NonBenefitMapNearbyPharmacySearchTabs {
  nonBenefitMapNearbyPharmacySearchTabs {
    id
    name
    diagnosisType
    diagnosisTypeId
    sortTypes {
      type
      title
    }
    filters {
      type
      title
      description
      mode
      activeIconUrl
      inactiveIconUrl
      subFilters {
        type
        title
        description
        mode
        inactiveIconUrl
        activeIconUrl
      }
    }
  }
}
    `;
export const useNonBenefitMapNearbyPharmacySearchTabsQuery = <
      TData = Types.NonBenefitMapNearbyPharmacySearchTabsQuery,
      TError = Types.GraphqlError
    >(
      variables?: Types.NonBenefitMapNearbyPharmacySearchTabsQueryVariables,
      options?: UseQueryOptions<Types.NonBenefitMapNearbyPharmacySearchTabsQuery, TError, TData>,
    ) =>
    useQuery<Types.NonBenefitMapNearbyPharmacySearchTabsQuery, TError, TData>(
      variables === undefined ? ['NonBenefitMapNearbyPharmacySearchTabs'] : ['NonBenefitMapNearbyPharmacySearchTabs', variables],
      gqlFetcher<Types.NonBenefitMapNearbyPharmacySearchTabsQuery, Types.NonBenefitMapNearbyPharmacySearchTabsQueryVariables>(NonBenefitMapNearbyPharmacySearchTabsDocument, 'NonBenefitMapNearbyPharmacySearchTabs', variables),
      options
    );

useNonBenefitMapNearbyPharmacySearchTabsQuery.getKey = (variables?: Types.NonBenefitMapNearbyPharmacySearchTabsQueryVariables) => variables === undefined ? ['NonBenefitMapNearbyPharmacySearchTabs'] : ['NonBenefitMapNearbyPharmacySearchTabs', variables];
;

useNonBenefitMapNearbyPharmacySearchTabsQuery.fetcher = (variables?: Types.NonBenefitMapNearbyPharmacySearchTabsQueryVariables, options?: RequestInit['headers']) => gqlFetcher<Types.NonBenefitMapNearbyPharmacySearchTabsQuery, Types.NonBenefitMapNearbyPharmacySearchTabsQueryVariables>(NonBenefitMapNearbyPharmacySearchTabsDocument, 'NonBenefitMapNearbyPharmacySearchTabs', variables, options);